var _e = Object.defineProperty;
var be = (r, t, n) => t in r ? _e(r, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : r[t] = n;
var P = (r, t, n) => (be(r, typeof t != "symbol" ? t + "" : t, n), n);
import { d as dayjs, u as utc, t as timezone, p as process, c as commonjsGlobal, r as registerInstance, a as createEvent, b as debug, N as NylasIdentityRequestWrapper, i as instance, h, H as Host, g as getElement, e as createStore, B as Buffer, F as Fragment, f as dataResponse, j as getCalendarRange } from "./index-6e735f92.js";
import { N as NylasBaseProvider, X as Xr } from "./index.es-4615d47c-9156501b.js";
import { L as LANGUAGE_CODE, a as LANGUAGE_MAP, C as CONFIGURATION_EVENT_TYPE, E as EXPERIMENTAL_FEATURES } from "./constants-3d8016e3-3c080f00.js";
import "react";
import "react/jsx-runtime";
import "react-dom";
dayjs.extend(utc);
dayjs.extend(timezone);
class NylasSchedulerConfigAPIConnector {
  constructor({ nylasApiRequest: t, nylasSchedulerConfigStore: n }) {
    this.nylasApiRequest = t, this.nylasSchedulerConfigStore = n;
  }
  async currentUser() {
    return this.nylasApiRequest ? this.nylasApiRequest.currentUser() : (console.warn("Nylas API Request is not initialized"), null);
  }
  async getCalendars() {
    var s;
    if (!this.nylasApiRequest)
      return console.warn("Nylas API Request is not initialized"), dataResponse(null, {
        message: "Error fetching calendars: Nylas API Request is not initialized"
      });
    const [t, n] = await this.nylasApiRequest.request({
      method: "GET",
      path: "calendars"
    });
    return n ? dataResponse(null, {
      message: "Error fetching calendars: " + n.message
    }) : Xr(t) ? dataResponse(null, {
      message: "Error fetching calendars: " + ((s = t.error) == null ? void 0 : s.message)
    }) : (this.nylasSchedulerConfigStore.state.calendars = t.data, dataResponse(t.data));
  }
  async getConfigurationById(t, n = !1) {
    var l;
    if (!this.nylasApiRequest)
      return console.warn("Nylas API Request is not initialized"), dataResponse(null, {
        message: "Error fetching configuration: Nylas API Request is not initialized"
      });
    if (!n) {
      const d = this.nylasSchedulerConfigStore.state.configurations.find((c) => c.id === t);
      if (d)
        return this.nylasSchedulerConfigStore.state.selectedConfiguration = d, dataResponse(d);
    }
    const [s, a] = await this.nylasApiRequest.request({
      method: "GET",
      path: `scheduling/configurations/${t}`
    });
    return a ? dataResponse(null, {
      message: "Error fetching configuration: " + a.message
    }) : Xr(s) ? dataResponse(null, {
      message: "Error fetching configuration: " + ((l = s.error) == null ? void 0 : l.message)
    }) : (this.nylasSchedulerConfigStore.state.selectedConfiguration = s.data, this.nylasSchedulerConfigStore.state.configurations.find((d) => d.id === t) ? this.nylasSchedulerConfigStore.state.configurations = this.nylasSchedulerConfigStore.state.configurations.map((d) => d.id === t ? s.data : d) : this.nylasSchedulerConfigStore.state.configurations = [...this.nylasSchedulerConfigStore.state.configurations, s.data], dataResponse(s.data));
  }
  async getConfigurations(t) {
    var l;
    if (!this.nylasApiRequest)
      return console.warn("Nylas API Request is not initialized"), dataResponse(null, {
        message: "Error fetching configurations: Nylas API Request is not initialized"
      });
    const n = 50, [s, a] = await this.nylasApiRequest.request({
      method: "GET",
      path: `scheduling/configurations?limit=${n}${t ? `&page_token=${t}` : ""}`
    });
    return a ? dataResponse(null, {
      message: "Error fetching configurations: " + a.message
    }) : Xr(s) ? dataResponse(null, {
      message: "Error fetching configurations: " + ((l = s.error) == null ? void 0 : l.message)
    }) : (this.nylasSchedulerConfigStore.state.configurations = s.data, this.nylasSchedulerConfigStore.state.listConfigurationsNextCursor = s.next_cursor || null, dataResponse(s.data));
  }
  async getMasterEventById(t) {
    var u, f;
    if (!this.nylasApiRequest)
      return console.warn("Nylas API Request is not initialized"), dataResponse(null, {
        message: "Error fetching master event: Nylas API Request is not initialized"
      });
    const n = this.nylasSchedulerConfigStore.state.selectedGroupEvent, s = (u = n == null ? void 0 : n.event) == null ? void 0 : u.calendar_id;
    if (!s)
      return console.warn("Calendar ID is not present"), dataResponse(null, {
        message: "Error fetching master event: Calendar ID is not present"
      });
    const a = new URLSearchParams();
    a.append("calendar_id", s);
    const [l, d] = await this.nylasApiRequest.request({
      method: "GET",
      path: `events/${t}?${a.toString()}`
    });
    if (d)
      return dataResponse(null, {
        message: "Error fetching master event: " + d.message
      });
    if (Xr(l))
      return dataResponse(null, {
        message: "Error fetching master event: " + ((f = l.error) == null ? void 0 : f.message)
      });
    const c = this.nylasSchedulerConfigStore.state.masterGroupEvents;
    return c[t] ? this.nylasSchedulerConfigStore.state.masterGroupEvents[t] = l.data : this.nylasSchedulerConfigStore.state.masterGroupEvents = { ...c, [t]: l.data }, dataResponse(l.data);
  }
  async createConfiguration(t) {
    var a;
    if (!this.nylasApiRequest)
      return console.warn("Nylas API Request is not initialized"), dataResponse(null, {
        message: "Error creating configuration: Nylas API Request is not initialized"
      });
    const [n, s] = await this.nylasApiRequest.request({
      method: "POST",
      path: "scheduling/configurations",
      body: t
    });
    return s ? dataResponse(null, {
      message: "Error creating configuration: " + s.message
    }) : Xr(n) ? dataResponse(null, {
      message: "Error creating configuration: " + ((a = n.error) == null ? void 0 : a.message)
    }) : (this.nylasSchedulerConfigStore.state.selectedConfiguration = n.data, this.nylasSchedulerConfigStore.state.configurations = [...this.nylasSchedulerConfigStore.state.configurations, n.data], dataResponse(n.data));
  }
  async updateConfiguration(t) {
    var a;
    if (!this.nylasApiRequest)
      return console.warn("Nylas API Request is not initialized"), dataResponse(null, {
        message: "Error updating configuration: Nylas API Request is not initialized"
      });
    const [n, s] = await this.nylasApiRequest.request({
      method: "PUT",
      path: `scheduling/configurations/${t.id}`,
      body: t
    });
    return s ? dataResponse(null, {
      message: "Error updating configuration: " + s.message
    }) : Xr(n) ? dataResponse(null, {
      message: "Error updating configuration: " + ((a = n.error) == null ? void 0 : a.message)
    }) : (this.nylasSchedulerConfigStore.state.selectedConfiguration = n.data, this.nylasSchedulerConfigStore.state.configurations.find((l) => l.id === t.id) ? this.nylasSchedulerConfigStore.state.configurations = this.nylasSchedulerConfigStore.state.configurations.map((l) => l.id === t.id ? n.data : l) : this.nylasSchedulerConfigStore.state.configurations = [...this.nylasSchedulerConfigStore.state.configurations, n.data], dataResponse(n.data));
  }
  async deleteConfiguration(t) {
    var a, l;
    if (!this.nylasApiRequest)
      return console.warn("Nylas API Request is not initialized"), dataResponse(null, {
        message: "Error deleting configuration: Nylas API Request is not initialized"
      });
    const [n, s] = await this.nylasApiRequest.request({
      method: "DELETE",
      path: `scheduling/configurations/${t}`
    });
    return s ? dataResponse(null, {
      message: "Error deleting configuration: " + s.message
    }) : Xr(n) ? dataResponse(null, {
      message: "Error deleting configuration: " + ((a = n.error) == null ? void 0 : a.message)
    }) : (this.nylasSchedulerConfigStore.state.configurations = this.nylasSchedulerConfigStore.state.configurations.filter((d) => d.id !== t), ((l = this.nylasSchedulerConfigStore.state.selectedConfiguration) == null ? void 0 : l.id) === t && this.nylasSchedulerConfigStore.resetSelectedConfiguration(), dataResponse(n.data));
  }
  async createGroupEvent(t, n) {
    var l;
    if (this.nylasSchedulerConfigStore.state.isLoading = !0, !this.nylasApiRequest)
      return console.warn("Nylas API Request is not initialized"), dataResponse(null, {
        message: "Error creating group event: Nylas API Request is not initialized"
      });
    const [s, a] = await this.nylasApiRequest.request({
      method: "POST",
      path: `scheduling/configurations/${n}/group-events`,
      body: t
    });
    return a ? (this.nylasSchedulerConfigStore.state.isLoading = !1, dataResponse(null, {
      message: "Error creating group event: " + a.message
    })) : Xr(s) ? (this.nylasSchedulerConfigStore.state.isLoading = !1, dataResponse(null, {
      message: "Error creating group event: " + ((l = s.error) == null ? void 0 : l.message)
    })) : (this.nylasSchedulerConfigStore.state.selectedGroupEvent = s.data, await this.getGroupEvents(n), this.nylasSchedulerConfigStore.state.isLoading = !1, dataResponse(s.data));
  }
  async getGroupEvents(t) {
    var c, u, f;
    if (!this.nylasApiRequest)
      return console.warn("Nylas API Request is not initialized"), dataResponse(null, {
        message: "Error fetching group events: Nylas API Request is not initialized"
      });
    const n = new URLSearchParams();
    n.append("show_all", "true");
    const s = this.nylasSchedulerConfigStore.state.calendarViewDateRange;
    if (s)
      n.append("start_time", s.start_time), n.append("end_time", s.end_time);
    else {
      const { startTime: p, endTime: g } = getCalendarRange((/* @__PURE__ */ new Date()).toISOString(), "week");
      n.append("start_time", p.toString()), n.append("end_time", g.toString());
    }
    const a = (u = (c = this.nylasSchedulerConfigStore.state.selectedConfiguration) == null ? void 0 : c.group_booking) == null ? void 0 : u.calendar_id;
    a && n.append("calendar_id", a);
    const [l, d] = await this.nylasApiRequest.request({
      method: "GET",
      path: `scheduling/configurations/${t}/group-events?${n.toString()}`
    });
    return d ? dataResponse(null, {
      message: "Error fetching group events: " + d.message
    }) : Xr(l) ? dataResponse(null, {
      message: "Error fetching group events: " + ((f = l.error) == null ? void 0 : f.message)
    }) : (this.nylasSchedulerConfigStore.state.groupEvents = l.data, dataResponse(l.data));
  }
  async updateGroupEventById(t, n) {
    var d;
    if (this.nylasSchedulerConfigStore.state.isLoading = !0, !this.nylasApiRequest)
      return console.warn("Nylas API Request is not initialized"), dataResponse(null, {
        message: "Error updating group event: Nylas API Request is not initialized"
      });
    const s = t.id;
    delete t.id;
    const [a, l] = await this.nylasApiRequest.request({
      method: "PATCH",
      path: `scheduling/configurations/${n}/group-events/${s}`,
      body: t
    });
    return l ? (this.nylasSchedulerConfigStore.state.isLoading = !1, dataResponse(null, {
      message: "Error updating group event: " + l.message
    })) : Xr(a) ? (this.nylasSchedulerConfigStore.state.isLoading = !1, dataResponse(null, {
      message: "Error updating group event: " + ((d = a.error) == null ? void 0 : d.message)
    })) : (this.nylasSchedulerConfigStore.state.selectedGroupEvent = a.data, await this.getGroupEvents(n), this.nylasSchedulerConfigStore.state.isLoading = !1, dataResponse(a.data));
  }
  async updateGroupEvent(t, n, s) {
    var g, m, y, w, b, x, R, A, k, U, N, O, I, T;
    this.nylasSchedulerConfigStore.state.isLoading = !0;
    const a = this.nylasSchedulerConfigStore.state.selectedGroupEvent, l = (g = a == null ? void 0 : a.event) == null ? void 0 : g.master_event_id, d = (m = a == null ? void 0 : a.event) == null ? void 0 : m.id, c = (w = (y = a == null ? void 0 : a.event) == null ? void 0 : y.when) == null ? void 0 : w.start_time, u = (x = (b = a == null ? void 0 : a.group_event_info) == null ? void 0 : b.rrule) == null ? void 0 : x[0], f = u ? u.split(";").filter((S) => !S.startsWith("UNTIL")).join(";") : "", p = c ? dayjs(c * 1e3).subtract(1, "minute").format("YYYYMMDDTHHmmss[Z]") : "";
    if (n === "this")
      return this.updateGroupEventById({
        ...t,
        id: d,
        recurrence: l ? void 0 : t.recurrence
      }, s);
    if (n === "future" && l) {
      const S = await this.createGroupEvent(t, s), v = {
        location: (R = a == null ? void 0 : a.event) == null ? void 0 : R.location,
        conferencing: (A = a == null ? void 0 : a.event) == null ? void 0 : A.conferencing,
        title: (k = a == null ? void 0 : a.event) == null ? void 0 : k.title,
        description: (U = a == null ? void 0 : a.event) == null ? void 0 : U.description,
        capacity: (N = a == null ? void 0 : a.group_event_info) == null ? void 0 : N.capacity,
        calendar_id: (O = a == null ? void 0 : a.event) == null ? void 0 : O.calendar_id,
        recurrence: f ? [f + ";UNTIL=" + p] : [`RRULE:FREQ=DAILY;UNTIL=${p}`]
      };
      return await this.updateGroupEventById({
        ...v,
        id: l
      }, s), [v, S];
    } else if (n === "all") {
      const S = t == null ? void 0 : t.when, v = (I = a == null ? void 0 : a.event) == null ? void 0 : I.when, L = (T = this.nylasSchedulerConfigStore.state.masterGroupEvents) == null ? void 0 : T[l];
      let _ = L == null ? void 0 : L.when;
      return (S == null ? void 0 : S.start_time) !== (v == null ? void 0 : v.start_time) && (_ = {
        ..._,
        start_time: (S == null ? void 0 : S.start_time) || (_ == null ? void 0 : _.start_time)
      }), (S == null ? void 0 : S.end_time) !== (v == null ? void 0 : v.end_time) && (_ = {
        ..._,
        end_time: (S == null ? void 0 : S.end_time) || (_ == null ? void 0 : _.end_time)
      }), (S == null ? void 0 : S.start_timezone) !== (v == null ? void 0 : v.start_timezone) && (_ = {
        ..._,
        start_timezone: (S == null ? void 0 : S.start_timezone) || (_ == null ? void 0 : _.start_timezone)
      }), (S == null ? void 0 : S.end_timezone) !== (v == null ? void 0 : v.end_timezone) && (_ = {
        ..._,
        end_timezone: (S == null ? void 0 : S.end_timezone) || (_ == null ? void 0 : _.end_timezone)
      }), this.updateGroupEventById({
        ...t,
        when: _,
        id: l
      }, s);
    }
    throw this.nylasSchedulerConfigStore.state.isLoading = !1, new Error("Invalid option");
  }
  async deleteGroupEvent(t, n, s) {
    var m, y, w, b, x, R, A, k, U, N, O, I;
    this.nylasSchedulerConfigStore.state.isLoading = !0;
    const a = this.nylasSchedulerConfigStore.state.selectedGroupEvent, l = (m = a == null ? void 0 : a.event) == null ? void 0 : m.master_event_id, d = (y = a == null ? void 0 : a.event) == null ? void 0 : y.id, c = (b = (w = a == null ? void 0 : a.event) == null ? void 0 : w.when) == null ? void 0 : b.start_time, u = (R = (x = a == null ? void 0 : a.group_event_info) == null ? void 0 : x.rrule) == null ? void 0 : R[0], f = u ? u.split(";").filter((T) => !T.startsWith("UNTIL")).join(";") : "", p = c ? dayjs(c * 1e3).format("YYYYMMDDTHHmmss[Z]") : "", g = {
      location: (A = a == null ? void 0 : a.event) == null ? void 0 : A.location,
      conferencing: (k = a == null ? void 0 : a.event) == null ? void 0 : k.conferencing,
      title: (U = a == null ? void 0 : a.event) == null ? void 0 : U.title,
      description: (N = a == null ? void 0 : a.event) == null ? void 0 : N.description,
      capacity: (O = a == null ? void 0 : a.group_event_info) == null ? void 0 : O.capacity,
      calendar_id: (I = a == null ? void 0 : a.event) == null ? void 0 : I.calendar_id,
      recurrence: f ? [f + ";UNTIL=" + p] : [`RRULE:UNTIL=${p}`]
    };
    if (n === "this" && d)
      return this.deleteGroupEventById(d, s);
    if (n === "future" && l && d)
      return await this.deleteGroupEventById(d, s), await this.updateGroupEventById({
        ...g,
        id: l
      }, s);
    if (n === "all" && l)
      return this.deleteGroupEventById(l, s);
    throw this.nylasSchedulerConfigStore.state.isLoading = !1, new Error("Invalid option");
  }
  async deleteGroupEventById(t, n) {
    var c, u, f;
    if (this.nylasSchedulerConfigStore.state.isLoading = !0, !this.nylasApiRequest)
      return console.warn("Nylas API Request is not initialized"), dataResponse(null, {
        message: "Error deleting group event: Nylas API Request is not initialized"
      });
    const s = new URLSearchParams(), a = (u = (c = this.nylasSchedulerConfigStore.state.selectedConfiguration) == null ? void 0 : c.group_booking) == null ? void 0 : u.calendar_id;
    a && s.append("calendar_id", a);
    const [l, d] = await this.nylasApiRequest.request({
      method: "DELETE",
      path: `scheduling/configurations/${n}/group-events/${t}?calendar_id=${a}`
    });
    return d ? (this.nylasSchedulerConfigStore.state.isLoading = !1, dataResponse(null, {
      message: "Error deleting group event: " + d.message
    })) : Xr(l) ? (this.nylasSchedulerConfigStore.state.isLoading = !1, dataResponse(null, {
      message: "Error deleting group event: " + ((f = l.error) == null ? void 0 : f.message)
    })) : (await this.getGroupEvents(n), this.nylasSchedulerConfigStore.state.isLoading = !1, dataResponse(l.data));
  }
  async importGroupEvent(t, n) {
    var c, u, f, p, g;
    if (this.nylasSchedulerConfigStore.state.isLoading = !0, !this.nylasApiRequest)
      return console.warn("Nylas API Request is not initialized"), dataResponse(null, {
        message: "Error importing group event: Nylas API Request is not initialized"
      });
    const s = new URLSearchParams(), a = (u = (c = this.nylasSchedulerConfigStore.state.selectedConfiguration) == null ? void 0 : c.group_booking) == null ? void 0 : u.calendar_id;
    a && s.append("calendar_id", a);
    const [l, d] = await this.nylasApiRequest.request({
      method: "POST",
      path: `scheduling/configurations/${n}/import-group-events?${s.toString()}`,
      body: t
    });
    return d ? (this.nylasSchedulerConfigStore.state.isLoading = !1, dataResponse(null, {
      message: "Error importing group event: " + d.message
    })) : Xr(l) ? (this.nylasSchedulerConfigStore.state.isLoading = !1, dataResponse(null, {
      message: "Error importing group event: " + ((f = l.error) == null ? void 0 : f.message)
    })) : (((g = (p = l.data) == null ? void 0 : p.imported_events) == null ? void 0 : g.length) > 0 && await this.getGroupEvents(n), this.nylasSchedulerConfigStore.state.isLoading = !1, dataResponse(l.data));
  }
}
class NylasSchedulerConfigConnector {
  constructor({ nylasApiRequest: t, nylasSchedulerConfigStore: n }) {
    this.nylasApiRequest = t, this.nylasSchedulerConfigStore = n;
  }
  init() {
    debug("NylasSchedulerConfigConnector init");
  }
  get schedulerConfigStore() {
    return this.nylasSchedulerConfigStore;
  }
  get schedulerConfig() {
    return this._schedulerConfigConnector ? this._schedulerConfigConnector : (this._schedulerConfigConnector = new NylasSchedulerConfigAPIConnector({
      nylasApiRequest: this.nylasApiRequest,
      nylasSchedulerConfigStore: this.nylasSchedulerConfigStore
    }), this._schedulerConfigConnector);
  }
  resetStores() {
    debug("NylasSchedulerConfigConnector resetStores"), this.nylasSchedulerConfigStore.reset();
  }
  async logout() {
    debug("NylasSchedulerConfigConnector logout"), this.resetStores();
  }
}
function CreateNylasSchedulerConfigStore(r = {}) {
  const t = {
    selectedConfiguration: {},
    configurations: [],
    groupEvents: [],
    listConfigurationsNextCursor: null,
    calendars: [],
    currentUser: null,
    action: null,
    additionalParticipants: [],
    requiresSlug: !1,
    masterGroupEvents: {},
    isLoading: !1,
    ...r
  }, n = createStore(t);
  function s() {
    n.set("selectedConfiguration", { ...r.selectedConfiguration });
  }
  return n.onChange("action", async (a) => {
    a || s();
  }), {
    ...n,
    resetSelectedConfiguration: s
  };
}
class LocalStorage {
  get(t) {
    return new Promise((n) => {
      const s = window.localStorage.getItem(t);
      n(s ? JSON.parse(s) : null);
    });
  }
  async remove(t) {
    return window.localStorage.removeItem(t), new Promise((n) => {
      n(null);
    });
  }
  set(t, n) {
    return window.localStorage.setItem(t, JSON.stringify(n)), new Promise((s) => {
      s(null);
    });
  }
}
const PKCE_KEY = "pkce", GRANT_KEY = "grant", USER_KEY = "user";
class Storage {
  constructor(t) {
    P(this, "Storage", new LocalStorage());
    if (t) {
      this.Storage = t;
      return;
    }
  }
  setPKCE(t) {
    const n = Buffer.from(t);
    this.Storage.set(PKCE_KEY, n.toString("base64"));
  }
  async getPKCE() {
    try {
      const t = await this.Storage.get(PKCE_KEY);
      if (t)
        return Buffer.from(t, "base64").toString("utf8");
    } catch {
      return null;
    }
    return null;
  }
  removePKCE() {
    this.Storage.remove(PKCE_KEY);
  }
  setGrant(t, n = !1) {
    const { grant_id: s } = t;
    this.Storage.set(`${GRANT_KEY}${n ? "-" + s : ""}`, t);
  }
  removeGrant(t, n = !1) {
    this.Storage.remove(`${GRANT_KEY}${n ? "-" + t : ""}`);
  }
  async getGrant(t, n = !1) {
    const s = await this.Storage.get(`${GRANT_KEY}${n ? "-" + t : ""}`);
    return s || null;
  }
  // setUserToken is used to store the IDToken in storage
  async setUserToken(t) {
    const n = await this.getUserTokens();
    if (n)
      if (n.find((a) => a.sub === t.sub)) {
        const a = n.map((l) => (l.sub === t.sub && (l = t), l));
        this.Storage.set(USER_KEY, a);
      } else {
        const a = [...n, t];
        this.Storage.set(USER_KEY, a);
      }
    else
      this.Storage.set(USER_KEY, [t]);
  }
  // getUserToken is used to retrieve a specific IDToken from storage
  async getUserToken(t = "") {
    const n = await this.Storage.get(USER_KEY);
    return n ? t === "" ? n[0] : n.find((a) => a.sub === t) : null;
  }
  // getUserTokens is used to retrieve all IDTokens from storage
  async getUserTokens() {
    const t = await this.Storage.get(USER_KEY);
    return t || null;
  }
  // removeUserTokens is used to remove all IDTokens from storage
  removeUserTokens() {
    this.Storage.remove(USER_KEY);
  }
  // removeUserToken is used to remove a specific IDToken from storage
  async removeUserToken(t) {
    const n = await this.getUserTokens(), s = n == null ? void 0 : n.filter((a) => a.sub !== t);
    this.Storage.set(USER_KEY, s);
  }
  async clearSession() {
    const t = await this.getUserTokens();
    t == null || t.forEach((n) => {
      this.removeGrant(n.sub);
    }), this.removePKCE(), this.removeUserTokens();
  }
}
class IndexedDBStorage {
  constructor() {
    P(this, "databaseName", "identity-db");
    P(this, "storeName", "identity");
  }
  get(t) {
    const n = this;
    return new Promise((s, a) => {
      n.openDatabase().then(function(l) {
        const d = l.transaction(n.storeName, "readwrite"), u = d.objectStore(n.storeName).get(t);
        u.onsuccess = () => {
          s(u.result);
        }, u.onerror = () => {
          a(u.error);
        }, d.oncomplete = () => {
          l.close();
        };
      });
    });
  }
  async remove(t) {
    const n = this;
    return new Promise((s, a) => {
      const l = indexedDB.open(this.databaseName);
      l.onupgradeneeded = function(d) {
        d.target.result.createObjectStore(n.storeName);
      }, l.onerror = () => {
        a(l.error);
      }, l.onsuccess = (d) => {
        const c = d.target.result, u = c.transaction(this.storeName, "readwrite"), p = u.objectStore(this.storeName).delete(t);
        p.onsuccess = () => {
          s(null);
        }, p.onerror = () => {
          a(p.error);
        }, u.oncomplete = () => {
          c.close();
        };
      };
    });
  }
  set(t, n) {
    return new Promise((s, a) => {
      const l = indexedDB.open(this.databaseName);
      l.onerror = () => {
        a(l.error);
      }, l.onupgradeneeded = (d) => {
        d.target.result.createObjectStore(this.storeName);
      }, l.onsuccess = (d) => {
        const c = d.target.result, u = c.transaction(this.storeName, "readwrite"), p = u.objectStore(this.storeName).put(n, t);
        p.onsuccess = () => {
          s(n);
        }, p.onerror = () => {
          a(p.error);
        }, u.oncomplete = () => {
          c.close();
        };
      };
    });
  }
  openDatabase() {
    const t = this;
    return new Promise(function(n, s) {
      const a = indexedDB.open(t.databaseName, 2);
      a.onupgradeneeded = function(l) {
        l.target.result.createObjectStore(t.storeName);
      }, a.onsuccess = function(l) {
        n(l.target.result);
      }, a.onerror = function(l) {
        s(l.error);
      };
    });
  }
}
var sha256 = { exports: {} };
(function(module) {
  (function() {
    var ERROR = "input is invalid type", WINDOW = typeof window == "object", root = WINDOW ? window : {};
    root.JS_SHA256_NO_WINDOW && (WINDOW = !1);
    var WEB_WORKER = !WINDOW && typeof self == "object", NODE_JS = !root.JS_SHA256_NO_NODE_JS && typeof process == "object" && process.versions && process.versions.node;
    NODE_JS ? root = commonjsGlobal : WEB_WORKER && (root = self);
    var COMMON_JS = !root.JS_SHA256_NO_COMMON_JS && !0 && module.exports, ARRAY_BUFFER = !root.JS_SHA256_NO_ARRAY_BUFFER && typeof ArrayBuffer < "u", HEX_CHARS = "0123456789abcdef".split(""), EXTRA = [-2147483648, 8388608, 32768, 128], SHIFT = [24, 16, 8, 0], K = [
      1116352408,
      1899447441,
      3049323471,
      3921009573,
      961987163,
      1508970993,
      2453635748,
      2870763221,
      3624381080,
      310598401,
      607225278,
      1426881987,
      1925078388,
      2162078206,
      2614888103,
      3248222580,
      3835390401,
      4022224774,
      264347078,
      604807628,
      770255983,
      1249150122,
      1555081692,
      1996064986,
      2554220882,
      2821834349,
      2952996808,
      3210313671,
      3336571891,
      3584528711,
      113926993,
      338241895,
      666307205,
      773529912,
      1294757372,
      1396182291,
      1695183700,
      1986661051,
      2177026350,
      2456956037,
      2730485921,
      2820302411,
      3259730800,
      3345764771,
      3516065817,
      3600352804,
      4094571909,
      275423344,
      430227734,
      506948616,
      659060556,
      883997877,
      958139571,
      1322822218,
      1537002063,
      1747873779,
      1955562222,
      2024104815,
      2227730452,
      2361852424,
      2428436474,
      2756734187,
      3204031479,
      3329325298
    ], OUTPUT_TYPES = ["hex", "array", "digest", "arrayBuffer"], blocks = [];
    (root.JS_SHA256_NO_NODE_JS || !Array.isArray) && (Array.isArray = function(r) {
      return Object.prototype.toString.call(r) === "[object Array]";
    }), ARRAY_BUFFER && (root.JS_SHA256_NO_ARRAY_BUFFER_IS_VIEW || !ArrayBuffer.isView) && (ArrayBuffer.isView = function(r) {
      return typeof r == "object" && r.buffer && r.buffer.constructor === ArrayBuffer;
    });
    var createOutputMethod = function(r, t) {
      return function(n) {
        return new Sha256(t, !0).update(n)[r]();
      };
    }, createMethod = function(r) {
      var t = createOutputMethod("hex", r);
      NODE_JS && (t = nodeWrap(t, r)), t.create = function() {
        return new Sha256(r);
      }, t.update = function(a) {
        return t.create().update(a);
      };
      for (var n = 0; n < OUTPUT_TYPES.length; ++n) {
        var s = OUTPUT_TYPES[n];
        t[s] = createOutputMethod(s, r);
      }
      return t;
    }, nodeWrap = function(method, is224) {
      var crypto = eval("require('crypto')"), Buffer = eval("require('buffer').Buffer"), algorithm = is224 ? "sha224" : "sha256", nodeMethod = function(r) {
        if (typeof r == "string")
          return crypto.createHash(algorithm).update(r, "utf8").digest("hex");
        if (r == null)
          throw new Error(ERROR);
        return r.constructor === ArrayBuffer && (r = new Uint8Array(r)), Array.isArray(r) || ArrayBuffer.isView(r) || r.constructor === Buffer ? crypto.createHash(algorithm).update(new Buffer(r)).digest("hex") : method(r);
      };
      return nodeMethod;
    }, createHmacOutputMethod = function(r, t) {
      return function(n, s) {
        return new HmacSha256(n, t, !0).update(s)[r]();
      };
    }, createHmacMethod = function(r) {
      var t = createHmacOutputMethod("hex", r);
      t.create = function(a) {
        return new HmacSha256(a, r);
      }, t.update = function(a, l) {
        return t.create(a).update(l);
      };
      for (var n = 0; n < OUTPUT_TYPES.length; ++n) {
        var s = OUTPUT_TYPES[n];
        t[s] = createHmacOutputMethod(s, r);
      }
      return t;
    };
    function Sha256(r, t) {
      t ? (blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0, this.blocks = blocks) : this.blocks = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0], r ? (this.h0 = 3238371032, this.h1 = 914150663, this.h2 = 812702999, this.h3 = 4144912697, this.h4 = 4290775857, this.h5 = 1750603025, this.h6 = 1694076839, this.h7 = 3204075428) : (this.h0 = 1779033703, this.h1 = 3144134277, this.h2 = 1013904242, this.h3 = 2773480762, this.h4 = 1359893119, this.h5 = 2600822924, this.h6 = 528734635, this.h7 = 1541459225), this.block = this.start = this.bytes = this.hBytes = 0, this.finalized = this.hashed = !1, this.first = !0, this.is224 = r;
    }
    Sha256.prototype.update = function(r) {
      if (!this.finalized) {
        var t, n = typeof r;
        if (n !== "string") {
          if (n === "object") {
            if (r === null)
              throw new Error(ERROR);
            if (ARRAY_BUFFER && r.constructor === ArrayBuffer)
              r = new Uint8Array(r);
            else if (!Array.isArray(r) && (!ARRAY_BUFFER || !ArrayBuffer.isView(r)))
              throw new Error(ERROR);
          } else
            throw new Error(ERROR);
          t = !0;
        }
        for (var s, a = 0, l, d = r.length, c = this.blocks; a < d; ) {
          if (this.hashed && (this.hashed = !1, c[0] = this.block, c[16] = c[1] = c[2] = c[3] = c[4] = c[5] = c[6] = c[7] = c[8] = c[9] = c[10] = c[11] = c[12] = c[13] = c[14] = c[15] = 0), t)
            for (l = this.start; a < d && l < 64; ++a)
              c[l >> 2] |= r[a] << SHIFT[l++ & 3];
          else
            for (l = this.start; a < d && l < 64; ++a)
              s = r.charCodeAt(a), s < 128 ? c[l >> 2] |= s << SHIFT[l++ & 3] : s < 2048 ? (c[l >> 2] |= (192 | s >> 6) << SHIFT[l++ & 3], c[l >> 2] |= (128 | s & 63) << SHIFT[l++ & 3]) : s < 55296 || s >= 57344 ? (c[l >> 2] |= (224 | s >> 12) << SHIFT[l++ & 3], c[l >> 2] |= (128 | s >> 6 & 63) << SHIFT[l++ & 3], c[l >> 2] |= (128 | s & 63) << SHIFT[l++ & 3]) : (s = 65536 + ((s & 1023) << 10 | r.charCodeAt(++a) & 1023), c[l >> 2] |= (240 | s >> 18) << SHIFT[l++ & 3], c[l >> 2] |= (128 | s >> 12 & 63) << SHIFT[l++ & 3], c[l >> 2] |= (128 | s >> 6 & 63) << SHIFT[l++ & 3], c[l >> 2] |= (128 | s & 63) << SHIFT[l++ & 3]);
          this.lastByteIndex = l, this.bytes += l - this.start, l >= 64 ? (this.block = c[16], this.start = l - 64, this.hash(), this.hashed = !0) : this.start = l;
        }
        return this.bytes > 4294967295 && (this.hBytes += this.bytes / 4294967296 << 0, this.bytes = this.bytes % 4294967296), this;
      }
    }, Sha256.prototype.finalize = function() {
      if (!this.finalized) {
        this.finalized = !0;
        var r = this.blocks, t = this.lastByteIndex;
        r[16] = this.block, r[t >> 2] |= EXTRA[t & 3], this.block = r[16], t >= 56 && (this.hashed || this.hash(), r[0] = this.block, r[16] = r[1] = r[2] = r[3] = r[4] = r[5] = r[6] = r[7] = r[8] = r[9] = r[10] = r[11] = r[12] = r[13] = r[14] = r[15] = 0), r[14] = this.hBytes << 3 | this.bytes >>> 29, r[15] = this.bytes << 3, this.hash();
      }
    }, Sha256.prototype.hash = function() {
      var r = this.h0, t = this.h1, n = this.h2, s = this.h3, a = this.h4, l = this.h5, d = this.h6, c = this.h7, u = this.blocks, f, p, g, m, y, w, b, x, R, A, k;
      for (f = 16; f < 64; ++f)
        y = u[f - 15], p = (y >>> 7 | y << 25) ^ (y >>> 18 | y << 14) ^ y >>> 3, y = u[f - 2], g = (y >>> 17 | y << 15) ^ (y >>> 19 | y << 13) ^ y >>> 10, u[f] = u[f - 16] + p + u[f - 7] + g << 0;
      for (k = t & n, f = 0; f < 64; f += 4)
        this.first ? (this.is224 ? (x = 300032, y = u[0] - 1413257819, c = y - 150054599 << 0, s = y + 24177077 << 0) : (x = 704751109, y = u[0] - 210244248, c = y - 1521486534 << 0, s = y + 143694565 << 0), this.first = !1) : (p = (r >>> 2 | r << 30) ^ (r >>> 13 | r << 19) ^ (r >>> 22 | r << 10), g = (a >>> 6 | a << 26) ^ (a >>> 11 | a << 21) ^ (a >>> 25 | a << 7), x = r & t, m = x ^ r & n ^ k, b = a & l ^ ~a & d, y = c + g + b + K[f] + u[f], w = p + m, c = s + y << 0, s = y + w << 0), p = (s >>> 2 | s << 30) ^ (s >>> 13 | s << 19) ^ (s >>> 22 | s << 10), g = (c >>> 6 | c << 26) ^ (c >>> 11 | c << 21) ^ (c >>> 25 | c << 7), R = s & r, m = R ^ s & t ^ x, b = c & a ^ ~c & l, y = d + g + b + K[f + 1] + u[f + 1], w = p + m, d = n + y << 0, n = y + w << 0, p = (n >>> 2 | n << 30) ^ (n >>> 13 | n << 19) ^ (n >>> 22 | n << 10), g = (d >>> 6 | d << 26) ^ (d >>> 11 | d << 21) ^ (d >>> 25 | d << 7), A = n & s, m = A ^ n & r ^ R, b = d & c ^ ~d & a, y = l + g + b + K[f + 2] + u[f + 2], w = p + m, l = t + y << 0, t = y + w << 0, p = (t >>> 2 | t << 30) ^ (t >>> 13 | t << 19) ^ (t >>> 22 | t << 10), g = (l >>> 6 | l << 26) ^ (l >>> 11 | l << 21) ^ (l >>> 25 | l << 7), k = t & n, m = k ^ t & s ^ A, b = l & d ^ ~l & c, y = a + g + b + K[f + 3] + u[f + 3], w = p + m, a = r + y << 0, r = y + w << 0;
      this.h0 = this.h0 + r << 0, this.h1 = this.h1 + t << 0, this.h2 = this.h2 + n << 0, this.h3 = this.h3 + s << 0, this.h4 = this.h4 + a << 0, this.h5 = this.h5 + l << 0, this.h6 = this.h6 + d << 0, this.h7 = this.h7 + c << 0;
    }, Sha256.prototype.hex = function() {
      this.finalize();
      var r = this.h0, t = this.h1, n = this.h2, s = this.h3, a = this.h4, l = this.h5, d = this.h6, c = this.h7, u = HEX_CHARS[r >> 28 & 15] + HEX_CHARS[r >> 24 & 15] + HEX_CHARS[r >> 20 & 15] + HEX_CHARS[r >> 16 & 15] + HEX_CHARS[r >> 12 & 15] + HEX_CHARS[r >> 8 & 15] + HEX_CHARS[r >> 4 & 15] + HEX_CHARS[r & 15] + HEX_CHARS[t >> 28 & 15] + HEX_CHARS[t >> 24 & 15] + HEX_CHARS[t >> 20 & 15] + HEX_CHARS[t >> 16 & 15] + HEX_CHARS[t >> 12 & 15] + HEX_CHARS[t >> 8 & 15] + HEX_CHARS[t >> 4 & 15] + HEX_CHARS[t & 15] + HEX_CHARS[n >> 28 & 15] + HEX_CHARS[n >> 24 & 15] + HEX_CHARS[n >> 20 & 15] + HEX_CHARS[n >> 16 & 15] + HEX_CHARS[n >> 12 & 15] + HEX_CHARS[n >> 8 & 15] + HEX_CHARS[n >> 4 & 15] + HEX_CHARS[n & 15] + HEX_CHARS[s >> 28 & 15] + HEX_CHARS[s >> 24 & 15] + HEX_CHARS[s >> 20 & 15] + HEX_CHARS[s >> 16 & 15] + HEX_CHARS[s >> 12 & 15] + HEX_CHARS[s >> 8 & 15] + HEX_CHARS[s >> 4 & 15] + HEX_CHARS[s & 15] + HEX_CHARS[a >> 28 & 15] + HEX_CHARS[a >> 24 & 15] + HEX_CHARS[a >> 20 & 15] + HEX_CHARS[a >> 16 & 15] + HEX_CHARS[a >> 12 & 15] + HEX_CHARS[a >> 8 & 15] + HEX_CHARS[a >> 4 & 15] + HEX_CHARS[a & 15] + HEX_CHARS[l >> 28 & 15] + HEX_CHARS[l >> 24 & 15] + HEX_CHARS[l >> 20 & 15] + HEX_CHARS[l >> 16 & 15] + HEX_CHARS[l >> 12 & 15] + HEX_CHARS[l >> 8 & 15] + HEX_CHARS[l >> 4 & 15] + HEX_CHARS[l & 15] + HEX_CHARS[d >> 28 & 15] + HEX_CHARS[d >> 24 & 15] + HEX_CHARS[d >> 20 & 15] + HEX_CHARS[d >> 16 & 15] + HEX_CHARS[d >> 12 & 15] + HEX_CHARS[d >> 8 & 15] + HEX_CHARS[d >> 4 & 15] + HEX_CHARS[d & 15];
      return this.is224 || (u += HEX_CHARS[c >> 28 & 15] + HEX_CHARS[c >> 24 & 15] + HEX_CHARS[c >> 20 & 15] + HEX_CHARS[c >> 16 & 15] + HEX_CHARS[c >> 12 & 15] + HEX_CHARS[c >> 8 & 15] + HEX_CHARS[c >> 4 & 15] + HEX_CHARS[c & 15]), u;
    }, Sha256.prototype.toString = Sha256.prototype.hex, Sha256.prototype.digest = function() {
      this.finalize();
      var r = this.h0, t = this.h1, n = this.h2, s = this.h3, a = this.h4, l = this.h5, d = this.h6, c = this.h7, u = [
        r >> 24 & 255,
        r >> 16 & 255,
        r >> 8 & 255,
        r & 255,
        t >> 24 & 255,
        t >> 16 & 255,
        t >> 8 & 255,
        t & 255,
        n >> 24 & 255,
        n >> 16 & 255,
        n >> 8 & 255,
        n & 255,
        s >> 24 & 255,
        s >> 16 & 255,
        s >> 8 & 255,
        s & 255,
        a >> 24 & 255,
        a >> 16 & 255,
        a >> 8 & 255,
        a & 255,
        l >> 24 & 255,
        l >> 16 & 255,
        l >> 8 & 255,
        l & 255,
        d >> 24 & 255,
        d >> 16 & 255,
        d >> 8 & 255,
        d & 255
      ];
      return this.is224 || u.push(c >> 24 & 255, c >> 16 & 255, c >> 8 & 255, c & 255), u;
    }, Sha256.prototype.array = Sha256.prototype.digest, Sha256.prototype.arrayBuffer = function() {
      this.finalize();
      var r = new ArrayBuffer(this.is224 ? 28 : 32), t = new DataView(r);
      return t.setUint32(0, this.h0), t.setUint32(4, this.h1), t.setUint32(8, this.h2), t.setUint32(12, this.h3), t.setUint32(16, this.h4), t.setUint32(20, this.h5), t.setUint32(24, this.h6), this.is224 || t.setUint32(28, this.h7), r;
    };
    function HmacSha256(r, t, n) {
      var s, a = typeof r;
      if (a === "string") {
        var l = [], d = r.length, c = 0, u;
        for (s = 0; s < d; ++s)
          u = r.charCodeAt(s), u < 128 ? l[c++] = u : u < 2048 ? (l[c++] = 192 | u >> 6, l[c++] = 128 | u & 63) : u < 55296 || u >= 57344 ? (l[c++] = 224 | u >> 12, l[c++] = 128 | u >> 6 & 63, l[c++] = 128 | u & 63) : (u = 65536 + ((u & 1023) << 10 | r.charCodeAt(++s) & 1023), l[c++] = 240 | u >> 18, l[c++] = 128 | u >> 12 & 63, l[c++] = 128 | u >> 6 & 63, l[c++] = 128 | u & 63);
        r = l;
      } else if (a === "object") {
        if (r === null)
          throw new Error(ERROR);
        if (ARRAY_BUFFER && r.constructor === ArrayBuffer)
          r = new Uint8Array(r);
        else if (!Array.isArray(r) && (!ARRAY_BUFFER || !ArrayBuffer.isView(r)))
          throw new Error(ERROR);
      } else
        throw new Error(ERROR);
      r.length > 64 && (r = new Sha256(t, !0).update(r).array());
      var f = [], p = [];
      for (s = 0; s < 64; ++s) {
        var g = r[s] || 0;
        f[s] = 92 ^ g, p[s] = 54 ^ g;
      }
      Sha256.call(this, t, n), this.update(p), this.oKeyPad = f, this.inner = !0, this.sharedMemory = n;
    }
    HmacSha256.prototype = new Sha256(), HmacSha256.prototype.finalize = function() {
      if (Sha256.prototype.finalize.call(this), this.inner) {
        this.inner = !1;
        var r = this.array();
        Sha256.call(this, this.is224, this.sharedMemory), this.update(this.oKeyPad), this.update(r), Sha256.prototype.finalize.call(this);
      }
    };
    var exports = createMethod();
    exports.sha256 = exports, exports.sha224 = createMethod(!0), exports.sha256.hmac = createHmacMethod(), exports.sha224.hmac = createHmacMethod(!0), COMMON_JS ? module.exports = exports : (root.sha256 = exports.sha256, root.sha224 = exports.sha224);
  })();
})(sha256);
var getRandomValues, rnds8 = new Uint8Array(16);
function rng() {
  if (!getRandomValues && (getRandomValues = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !getRandomValues))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return getRandomValues(rnds8);
}
const REGEX = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function validate(r) {
  return typeof r == "string" && REGEX.test(r);
}
var byteToHex = [];
for (var i = 0; i < 256; ++i)
  byteToHex.push((i + 256).toString(16).substr(1));
function stringify(r) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, n = (byteToHex[r[t + 0]] + byteToHex[r[t + 1]] + byteToHex[r[t + 2]] + byteToHex[r[t + 3]] + "-" + byteToHex[r[t + 4]] + byteToHex[r[t + 5]] + "-" + byteToHex[r[t + 6]] + byteToHex[r[t + 7]] + "-" + byteToHex[r[t + 8]] + byteToHex[r[t + 9]] + "-" + byteToHex[r[t + 10]] + byteToHex[r[t + 11]] + byteToHex[r[t + 12]] + byteToHex[r[t + 13]] + byteToHex[r[t + 14]] + byteToHex[r[t + 15]]).toLowerCase();
  if (!validate(n))
    throw TypeError("Stringified UUID is invalid");
  return n;
}
function v4(r, t, n) {
  r = r || {};
  var s = r.random || (r.rng || rng)();
  if (s[6] = s[6] & 15 | 64, s[8] = s[8] & 63 | 128, t) {
    n = n || 0;
    for (var a = 0; a < 16; ++a)
      t[n + a] = s[a];
    return t;
  }
  return stringify(s);
}
async function getBytes(r, t) {
  const n = r.getReader();
  let s;
  for (; !(s = await n.read()).done; )
    t(s.value);
}
function getLines(r) {
  let t, n, s, a = !1;
  return function(d) {
    t === void 0 ? (t = d, n = 0, s = -1) : t = concat(t, d);
    const c = t.length;
    let u = 0;
    for (; n < c; ) {
      a && (t[n] === 10 && (u = ++n), a = !1);
      let f = -1;
      for (; n < c && f === -1; ++n)
        switch (t[n]) {
          case 58:
            s === -1 && (s = n - u);
            break;
          case 13:
            a = !0;
          case 10:
            f = n;
            break;
        }
      if (f === -1)
        break;
      r(t.subarray(u, f), s), u = n, s = -1;
    }
    u === c ? t = void 0 : u !== 0 && (t = t.subarray(u), n -= u);
  };
}
function getMessages(r, t, n) {
  let s = newMessage();
  const a = new TextDecoder();
  return function(d, c) {
    if (d.length === 0)
      n == null || n(s), s = newMessage();
    else if (c > 0) {
      const u = a.decode(d.subarray(0, c)), f = c + (d[c + 1] === 32 ? 2 : 1), p = a.decode(d.subarray(f));
      switch (u) {
        case "data":
          s.data = s.data ? s.data + `
` + p : p;
          break;
        case "event":
          s.event = p;
          break;
        case "id":
          r(s.id = p);
          break;
        case "retry":
          const g = parseInt(p, 10);
          isNaN(g) || t(s.retry = g);
          break;
      }
    }
  };
}
function concat(r, t) {
  const n = new Uint8Array(r.length + t.length);
  return n.set(r), n.set(t, r.length), n;
}
function newMessage() {
  return {
    data: "",
    event: "",
    id: "",
    retry: void 0
  };
}
var __rest = function(r, t) {
  var n = {};
  for (var s in r)
    Object.prototype.hasOwnProperty.call(r, s) && t.indexOf(s) < 0 && (n[s] = r[s]);
  if (r != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, s = Object.getOwnPropertySymbols(r); a < s.length; a++)
      t.indexOf(s[a]) < 0 && Object.prototype.propertyIsEnumerable.call(r, s[a]) && (n[s[a]] = r[s[a]]);
  return n;
};
const EventStreamContentType = "text/event-stream", DefaultRetryInterval = 1e3, LastEventId = "last-event-id";
function fetchEventSource(r, t) {
  var { signal: n, headers: s, onopen: a, onmessage: l, onclose: d, onerror: c, openWhenHidden: u, fetch: f } = t, p = __rest(t, ["signal", "headers", "onopen", "onmessage", "onclose", "onerror", "openWhenHidden", "fetch"]);
  return new Promise((g, m) => {
    const y = Object.assign({}, s);
    y.accept || (y.accept = EventStreamContentType);
    let w;
    function b() {
      w.abort(), document.hidden || N();
    }
    u || document.addEventListener("visibilitychange", b);
    let x = DefaultRetryInterval, R = 0;
    function A() {
      document.removeEventListener("visibilitychange", b), window.clearTimeout(R), w.abort();
    }
    n == null || n.addEventListener("abort", () => {
      A(), g();
    });
    const k = f ?? window.fetch, U = a ?? defaultOnOpen;
    async function N() {
      var O;
      w = new AbortController();
      try {
        const I = await k(r, Object.assign(Object.assign({}, p), { headers: y, signal: w.signal }));
        await U(I), await getBytes(I.body, getLines(getMessages((T) => {
          T ? y[LastEventId] = T : delete y[LastEventId];
        }, (T) => {
          x = T;
        }, l))), d == null || d(), A(), g();
      } catch (I) {
        if (!w.signal.aborted)
          try {
            const T = (O = c == null ? void 0 : c(I)) !== null && O !== void 0 ? O : x;
            window.clearTimeout(R), R = window.setTimeout(N, T);
          } catch (T) {
            A(), m(T);
          }
      }
    }
    N();
  });
}
function defaultOnOpen(r) {
  const t = r.headers.get("content-type");
  if (!(t != null && t.startsWith(EventStreamContentType)))
    throw new Error(`Expected content-type to be ${EventStreamContentType}, Actual: ${t}`);
}
function Base64EncodeUrl(r) {
  return r.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}
function getTimestamp() {
  return Math.floor(Date.now() / 1e3);
}
function e(r) {
  this.message = r;
}
e.prototype = new Error(), e.prototype.name = "InvalidCharacterError";
var r$1 = typeof window < "u" && window.atob && window.atob.bind(window) || function(r) {
  var t = String(r).replace(/=+$/, "");
  if (t.length % 4 == 1)
    throw new e("'atob' failed: The string to be decoded is not correctly encoded.");
  for (var n, s, a = 0, l = 0, d = ""; s = t.charAt(l++); ~s && (n = a % 4 ? 64 * n + s : s, a++ % 4) ? d += String.fromCharCode(255 & n >> (-2 * a & 6)) : 0)
    s = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".indexOf(s);
  return d;
};
function t$1(r) {
  var t = r.replace(/-/g, "+").replace(/_/g, "/");
  switch (t.length % 4) {
    case 0:
      break;
    case 2:
      t += "==";
      break;
    case 3:
      t += "=";
      break;
    default:
      throw "Illegal base64url string!";
  }
  try {
    return function(n) {
      return decodeURIComponent(r$1(n).replace(/(.)/g, function(s, a) {
        var l = a.charCodeAt(0).toString(16).toUpperCase();
        return l.length < 2 && (l = "0" + l), "%" + l;
      }));
    }(t);
  } catch {
    return r$1(t);
  }
}
function n$1(r) {
  this.message = r;
}
function o(r, t) {
  if (typeof r != "string")
    throw new n$1("Invalid token specified");
  var n = (t = t || {}).header === !0 ? 0 : 1;
  try {
    return JSON.parse(t$1(r.split(".")[n]));
  } catch (s) {
    throw new n$1("Invalid token specified: " + s.message);
  }
}
n$1.prototype = new Error(), n$1.prototype.name = "InvalidTokenError";
class NylasSessions {
  constructor(t) {
    P(this, "clientId");
    P(this, "redirectUri");
    P(this, "accessType", "online");
    P(this, "domain", "http://api.nylas.com");
    P(this, "versioned", !1);
    P(this, "Storage");
    P(this, "hosted", !1);
    P(this, "multiAccount", !1);
    P(this, "loginId", "");
    if (this.clientId = t.clientId, this.redirectUri = t.redirectUri, t.domain && (this.domain = t.domain, this.domain.substring(this.domain.length - 3).includes("/v") && (this.versioned = !0)), t.multiAccount && (this.multiAccount = t.multiAccount), t.sw) {
      const n = new IndexedDBStorage();
      this.Storage = new Storage(n);
    } else
      this.Storage = new Storage();
    t.accessType && (this.accessType = t.accessType), t.loginId && (this.loginId = t.loginId), t.hosted && (this.hosted = t.hosted), t.disableInitCodeExchange !== !0 && this.codeExchange(null);
  }
  // Validates access token
  async validateAccessToken(t = "") {
    const n = await this.Storage.getGrant(t, this.multiAccount);
    if (!n)
      return !1;
    const { access_token: s } = n;
    try {
      return !!(await (await fetch(`${this.domain}/connect/tokeninfo?access_token=${s}`, {
        method: "GET"
      })).json()).data;
    } catch {
      return !1;
    }
  }
  // Validates id token
  async validateIDToken(t = "") {
    const n = await this.Storage.getGrant(t, this.multiAccount);
    if (!n)
      return !1;
    const { id_token: s } = n;
    try {
      const a = await fetch(`${this.domain}/connect/tokeninfo?id_token=${s}`, {
        method: "GET"
      });
      return !(a.status !== 200 || !(await a.json()).data);
    } catch {
      return !1;
    }
  }
  // Gets domain of UAS
  getDomain() {
    return this.domain;
  }
  // Gets auth link
  async auth(t) {
    this.hosted && (this.domain === window.location.origin || this.versioned && this.domain.includes(window.location.origin)) && await this.hostedSetCodeChallenge();
    const n = await this.generateAuthURL(t);
    if (t.popup) {
      this.popUp(n);
      return;
    }
    return n;
  }
  // Generates auth URL
  async generateAuthURL(t) {
    const n = await this.getCodeChallege();
    let s = `${this.domain}/connect/auth?client_id=${this.clientId}&redirect_uri=${this.redirectUri}&access_type=${this.accessType}&response_type=code`;
    return n && (s += `&code_challenge=${n}&code_challenge_method=S256&options=rotate_refresh_token`), t.provider && (s += `&provider=${t.provider}`), t.loginHint && (s += `&login_hint=${t.loginHint}`, t.includeGrantScopes && (s += `&include_grant_scopes=${t.includeGrantScopes}`)), t.scope && (s += `&scope=${t.scope.join(" ")}`), t.prompt && (s += `&prompt=${t.prompt}`), t.metadata && (s += `&metadata=${t.metadata}`), (t.state || this.loginId) && (s += `&state=${this.loginId ? this.loginId : t.state}`), s;
  }
  // Generates auth URL
  async generateReauthURL(t, n) {
    if (!t)
      throw new Error("Grant ID is required");
    const s = await this.Storage.getUserToken(t), a = await this.getCodeChallege();
    let l = `${this.domain}/connect/auth?client_id=${this.clientId}&redirect_uri=${this.redirectUri}&access_type=${this.accessType}&response_type=code`;
    return a && (l += `&code_challenge=${a}&code_challenge_method=S256&options=rotate_refresh_token`), s != null && s.provider && (l += `&provider=${s.provider}`), s != null && s.email && (l += `&login_hint=${s.email}`), n && (l += `&scope=${n.join(" ")}`), l;
  }
  // Generates UUID code challenge
  async generateCodeChallenge() {
    if (await this.Storage.getPKCE())
      return;
    const n = v4();
    this.Storage.setPKCE(n);
  }
  // Gets code challenge from URL query params
  async hostedSetCodeChallenge() {
    if (!this.hosted)
      throw console.error("Method only used with hosted flag enabled");
    const n = new URLSearchParams(window.location.search).get("code_challenge");
    if (!n) {
      if (await this.Storage.getPKCE())
        return;
      console.warn("Code challenge is recomended");
      return;
    }
    this.Storage.setPKCE(n);
  }
  // Gets code challenge from store
  async getCodeChallege() {
    if (this.hosted && (this.domain === window.location.origin || this.versioned && this.domain.includes(window.location.origin))) {
      const s = new URLSearchParams(window.location.search).get("code_challenge");
      return s || (console.warn("Code challenge is recomended"), "");
    }
    const t = await this.Storage.getPKCE();
    if (t) {
      const n = sha256.exports.sha256(t);
      let s = Buffer.from(n).toString("base64");
      return s = Base64EncodeUrl(s), s;
    }
    return "";
  }
  // checks if user is logged in
  async isLoggedIn() {
    if (this.hosted && (this.domain === window.location.origin || this.versioned && this.domain.includes(window.location.origin)))
      return !1;
    const t = await this.Storage.getUserTokens();
    return t && t.length > 0 ? (this.multiAccount && await this.generateCodeChallenge(), !0) : (await this.generateCodeChallenge(), !1);
  }
  // Checks if user is multi account
  isMultiAccount() {
    return this.multiAccount;
  }
  // Logs user out
  async logout() {
    const t = await this.getProfile();
    await this.Storage.clearSession();
    const n = { detail: t };
    window.dispatchEvent(new CustomEvent("onLogoutSuccess", n));
  }
  // Gets profile info from ID token
  async getProfile(t = "") {
    let n;
    return t ? n = await this.Storage.getUserToken(t) : n = await this.Storage.getUserToken(), n || null;
  }
  // Gets profile info from ID tokens
  async getProfiles() {
    const t = await this.Storage.getUserTokens();
    return t || null;
  }
  // Remove a specific profile
  async removeProfile(t) {
    return await this.Storage.removeUserToken(t), await this.Storage.removeGrant(t), null;
  }
  // IMAP authentication
  async authIMAP(t) {
    const n = await this.getCodeChallege(), s = {
      imap_username: t.imap_username,
      imap_password: t.imap_password,
      imap_host: t.imap_host,
      imap_port: t.imap_port,
      type: t.type,
      smtp_host: t.smtp_host,
      smtp_port: t.smtp_port,
      provider: t.provider,
      redirect_uri: this.redirectUri,
      state: t.state,
      public_application_id: this.clientId,
      access_type: this.accessType
    };
    return this.loginId && (s.id = this.loginId), t.smtp_username && t.smtp_password && (s.smtp_username = t.smtp_username, s.smtp_password = t.smtp_password), n != "" && (s.code_challenge = n, s.code_challenge_method = "S256"), await (await fetch(`${this.domain}/connect/login/imap`, {
      method: "POST",
      headers: new Headers({ "content-type": "application/json" }),
      body: JSON.stringify(s)
    })).json();
  }
  // EWS authentication
  async authEWS(t) {
    const n = await this.getCodeChallege(), s = {
      ...t,
      provider: "ews",
      redirect_uri: this.redirectUri,
      public_application_id: this.clientId,
      access_type: this.accessType
    };
    return this.loginId && (s.id = this.loginId), n != "" && (s.code_challenge = n, s.code_challenge_method = "S256"), await (await fetch(`${this.domain}/connect/login/ews`, {
      method: "POST",
      headers: new Headers({ "content-type": "application/json" }),
      body: JSON.stringify(s)
    })).json();
  }
  // Detects email
  async detectEmail(t) {
    return await (await fetch(`${this.versioned ? this.domain : this.domain + "/connect"}/providers/detect?client_id=${this.clientId}&email=${t}`, {
      method: "POST",
      headers: new Headers({ "content-type": "application/json" })
    })).json();
  }
  // Gets app info from UAS
  async applicationInfo() {
    return (await (await fetch(`${this.versioned ? this.domain : this.domain + "/connect"}/applications?client_id=${this.clientId}`, {
      method: "GET",
      headers: new Headers({ "content-type": "application/json" })
    })).json()).data;
  }
  // Gets providers form UAS
  async getAvailableProviders() {
    const t = await fetch(`${this.domain}/connect/providers/find?client_id=${this.clientId}`, {
      method: "GET",
      headers: new Headers({ "content-type": "application/json" })
    });
    return t ? (await t.json()).data : null;
  }
  // EVENT HOOKS
  onLoginSuccess(t) {
    window.addEventListener("onLoginSuccess", (n) => t(n));
  }
  onLogoutSuccess(t) {
    window.addEventListener("onLogoutSuccess", (n) => t(n));
  }
  onLoginFail(t) {
    window.addEventListener("onLoginFail", (n) => t(n));
  }
  onTokenRefreshSuccess(t) {
    window.addEventListener("onTokenRefreshSuccess", (n) => t(n));
  }
  onTokenRefreshFail(t) {
    window.addEventListener("onTokenRefreshFail", (n) => t(n));
  }
  onSessionExpired(t) {
    window.addEventListener("onSessionExpired", (n) => t(n));
  }
  // Exchanges code for ID token and refresh and access tokens
  async codeExchange(t) {
    let n = new URLSearchParams(window.location.search);
    t && (n = new URLSearchParams(t));
    const s = n.get("code"), a = n.get("state"), l = n.get("error"), d = n.get("error_description"), c = n.get("error_code");
    if (l && d && c) {
      const f = {
        detail: { error: l, error_description: d, error_code: c }
      };
      return window.dispatchEvent(new CustomEvent("onLoginFail", f)), window.history.pushState({}, document.title, window.location.pathname), !1;
    }
    if (!s)
      return console.warn("No code found"), !1;
    if (window.opener && window.name === "uas-popup")
      return console.warn("Popup window detected"), !1;
    const u = await this.Storage.getPKCE();
    if (!u)
      return console.warn("No code verifier found"), !1;
    try {
      const f = {
        client_id: this.clientId,
        redirect_uri: this.redirectUri,
        code: s,
        grant_type: "authorization_code",
        code_verifier: u
      }, g = await (await fetch(`${this.domain}/connect/token`, {
        method: "POST",
        headers: new Headers({ "content-type": "application/json" }),
        body: JSON.stringify(f)
      })).json();
      if (g) {
        if (g.error) {
          const y = { detail: g };
          return window.dispatchEvent(new CustomEvent("onLoginFail", y)), !0;
        }
        const m = await this.handleCodeExchangeResponse(g);
        if (m.valid) {
          a && (m.data.state = a);
          const y = { detail: m.data };
          window.dispatchEvent(new CustomEvent("onLoginSuccess", y)), window.history.pushState({}, document.title, window.location.pathname);
        } else {
          const y = { detail: m.data };
          return window.dispatchEvent(new CustomEvent("onLoginFail", y)), !0;
        }
      }
      return this.Storage.removePKCE(), !0;
    } catch (f) {
      const p = { detail: f };
      return window.dispatchEvent(new CustomEvent("onLoginFail", p)), window.history.pushState({}, document.title, window.location.pathname), !1;
    }
  }
  // Token Exchange for session  maintenece
  async tokenExchange(t = "") {
    const n = await this.Storage.getGrant(t, this.multiAccount);
    if (!n)
      return !1;
    const s = n.refresh_token;
    try {
      const a = {
        client_id: this.clientId,
        redirect_uri: this.redirectUri,
        refresh_token: s,
        grant_type: "refresh_token"
      }, d = await (await fetch(`${this.domain}/connect/token`, {
        method: "POST",
        headers: new Headers({ "content-type": "application/json" }),
        body: JSON.stringify(a)
      })).json();
      if (d) {
        if (d.error) {
          const p = { detail: d };
          return window.dispatchEvent(new CustomEvent("onTokenRefreshFail", p)), !0;
        }
        const c = getTimestamp();
        if (d.expires_in = c + d.expires_in, this.Storage.setGrant(d, this.multiAccount), !await this.validateIDToken(t)) {
          const p = { detail: d };
          return window.dispatchEvent(new CustomEvent("onTokenRefreshFail", p)), !0;
        }
        const f = { detail: d };
        return window.dispatchEvent(new CustomEvent("onTokenRefreshSuccess", f)), !0;
      }
      this.Storage.removePKCE();
    } catch (a) {
      const l = { detail: a };
      return window.dispatchEvent(new CustomEvent("onTokenRefreshFail", l)), !1;
    }
  }
  // Handles the response of code exchange
  async handleCodeExchangeResponse(t) {
    if (t.error)
      return {
        data: t,
        valid: !1
      };
    const s = getTimestamp();
    t.expires_in = s + t.expires_in, this.Storage.setGrant(t, this.multiAccount);
    const a = o(t.id_token);
    return a.status = "authenticated", this.Storage.setUserToken(a), await this.validateIDToken(a.sub) ? {
      data: t,
      valid: !0
    } : {
      data: t,
      valid: !1
    };
  }
  // Regulates POPUP behaivior
  async popUp(t) {
    const a = window.screenX + (window.outerWidth - 500) / 2, l = window.screenY + (window.outerHeight - 600) / 2.5, d = "uas-popup", c = t, u = window.open(c, d, `width=500,height=600,left=${a},top=${l}`);
    if (!u)
      return;
    const f = setInterval(async () => {
      if (u.closed) {
        const p = {
          detail: { error_description: "OAuth provider window closed" }
        };
        window.dispatchEvent(new CustomEvent("onLoginFail", p)), f && clearInterval(f);
        return;
      }
      try {
        const p = u.location.href.split("?");
        if (!p[0])
          return;
        const g = u.location.search;
        if (u.history.pushState({}, document.title, window.location.pathname), p[0] === this.redirectUri && p.length > 1) {
          const m = await this.codeExchange(g);
          u.close(), m && location.reload(), f && clearInterval(f);
          return;
        }
      } catch {
        return;
      }
    }, 1e3);
  }
  // Returns access token
  async getAccessToken(t = "") {
    const n = getTimestamp(), s = await this.Storage.getGrant(t, this.multiAccount);
    if (!s)
      return null;
    const { access_token: a, expires_in: l } = s, d = a;
    return d && l && l > getTimestamp() && l - n > 30 ? d : (await this.tokenExchange(t), (await this.Storage.getGrant(t, this.multiAccount)).access_token);
  }
  async sse(t, n) {
    const s = n.headers || {}, a = s["Grant-ID"];
    let l = "";
    if (this.multiAccount) {
      if (!a)
        throw this.logout(), new Error("Grant ID is required for multi account calls");
      l = await this.getAccessToken(a);
    } else
      l = await this.getAccessToken();
    return delete s["Grant-ID"], s.Authorization = `Bearer ${l}`, s["content-type"] || (s["content-type"] = "application/json"), fetchEventSource(`${this.domain}/${t}`, {
      ...n,
      headers: s
    });
  }
  // Used to call Nylas API endpoints
  async fetch(t, n, s = !0, a) {
    let l = "", d = 1;
    if (this.multiAccount) {
      if (!n.grant_id)
        throw this.logout(), new Error("Grant ID is required for multi account calls");
      const u = await this.getProfiles();
      d = u ? u.length : 1, l = await this.getAccessToken(n.grant_id);
    } else
      l = await this.getAccessToken();
    if (!l)
      throw new Error("Access token not found");
    let c = n.headers;
    Headers.prototype.isPrototypeOf(c) ? (c.append("Authorization", `Bearer ${l}`), c.has("content-type") || c.append("content-type", "application/json")) : c = new Headers({
      Authorization: `Bearer ${l}`,
      "content-type": "application/json"
    });
    try {
      n != null && n.body && (n.body = JSON.stringify(n == null ? void 0 : n.body));
      const u = await fetch(`${a || this.domain}/${t}`, {
        ...n,
        headers: c
      });
      if (!s)
        return u;
      const f = await (u == null ? void 0 : u.json());
      if (!await this.isAuthenticatedResponse(u.status, f)) {
        if (d > 1) {
          const g = await this.getProfile(n.grant_id);
          if (g) {
            g.status = "unauthorized", await this.Storage.setUserToken(g);
            const m = {
              detail: { user: g }
            };
            window.dispatchEvent(new CustomEvent("onSessionExpired", m));
          }
        } else {
          const m = {
            detail: { user: await this.Storage.getUserToken() }
          };
          window.dispatchEvent(new CustomEvent("onSessionExpired", m));
        }
        this.logout();
        return;
      }
      return f;
    } catch (u) {
      throw u;
    }
  }
  async fetchRequest(t, n, s, a = !0, l, d) {
    const c = await this.isLoggedIn(), u = new URL(t, l ?? this.domain), f = new Headers();
    if (f.append("Accept", "application/json"), f.append("Content-Type", "application/json"), f.append("User-Agent", "nylas-identity"), c) {
      const m = await this.getAccessToken();
      f.append("Authorization", `Bearer ${m}`);
    }
    const p = await fetch(u.toString(), {
      method: n || "GET",
      headers: f,
      mode: "cors",
      referrer: location.origin,
      body: s ? JSON.stringify(s) : void 0,
      ...d || {}
    });
    return a ? await p.json() : p.body;
  }
  // Checks if the response is not 401
  async isAuthenticatedResponse(t, n) {
    var s;
    return !(t == 401 && ((s = n == null ? void 0 : n.error) == null ? void 0 : s.type) == "token.unauthorized_access");
  }
  addAPIKey(t, n, s) {
    this.Storage.setUserToken({
      aud: "https://api-staging.us.nylas.com/",
      exp: 2e9,
      email_verified: !0,
      iat: getTimestamp(),
      iss: "",
      email: n,
      provider: "virtual-calendar",
      status: "authenticated",
      name: n,
      sub: t
    }), this.Storage.setGrant({
      grant_id: t,
      access_token: s,
      expires_in: 2e9
    }, this.multiAccount);
  }
}
var B = { isMounted: function() {
  return !1;
}, enqueueForceUpdate: function() {
}, enqueueReplaceState: function() {
}, enqueueSetState: function() {
} }, C = Object.assign, D = {};
function E(r, t, n) {
  this.props = r, this.context = t, this.refs = D, this.updater = n || B;
}
E.prototype.isReactComponent = {};
E.prototype.setState = function(r, t) {
  if (typeof r != "object" && typeof r != "function" && r != null)
    throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
  this.updater.enqueueSetState(this, r, t, "setState");
};
E.prototype.forceUpdate = function(r) {
  this.updater.enqueueForceUpdate(this, r, "forceUpdate");
};
function F() {
}
F.prototype = E.prototype;
function G(r, t, n) {
  this.props = r, this.context = t, this.refs = D, this.updater = n || B;
}
var H = G.prototype = new F();
H.constructor = G;
C(H, E.prototype);
H.isPureReactComponent = !0;
const LoginRequired = ({ authenticationUrl: r }) => h(
  "div",
  { class: "login-required", part: "nse__login-required login-component" },
  h(
    "div",
    { class: "card", part: "nse__login-required-card" },
    h("p", { part: "nse__login-required-text" }, "Log into your account to use the Scheduler Editor."),
    h(
      "button",
      { class: "google-button", part: "nse__login-required-google-button", onClick: async (t) => {
        t.preventDefault();
        const n = await r("google");
        n ? window.location.href = n : console.error("[nylas-scheduler-editor] Unable to get authentication URL.");
      } },
      h(
        "span",
        { class: "icon" },
        h("google-logo-icon", { width: "15", height: "15" })
      ),
      "Continue with Google"
    ),
    h(
      "button",
      { class: "microsoft-button", part: "nse__login-required-microsoft-button", onClick: async (t) => {
        t.preventDefault();
        const n = await r("microsoft");
        n ? window.location.href = n : console.error("[nylas-scheduler-editor] Unable to get authentication URL.");
      } },
      h(
        "span",
        { class: "icon" },
        h("microsoft-logo-icon", { width: "15", height: "15" })
      ),
      "Continue with Microsoft"
    ),
    h(
      "button",
      { class: "other-provider-button", part: "nse__login-required-other-provider-button", onClick: async (t) => {
        t.preventDefault();
        const n = await r();
        n ? window.location.href = n : console.error("[nylas-scheduler-editor] Unable to get authentication URL.");
      } },
      "View all providers ",
      h("chevron-icon", { width: "17", height: "17" })
    ),
    h("small", { class: "disclaimer-text", part: "nse__login-required-disclaimer-text" }, "* You will be redirected to authenticate your account.")
  )
);
function ExpressFlow({ currentUser: r, calendars: t, selectedEventType: n, experimentalFeatures: s }) {
  const a = (t == null ? void 0 : t.find((d) => d.is_primary)) || (t == null ? void 0 : t[0]), l = (s == null ? void 0 : s[EXPERIMENTAL_FEATURES.group_events]) || !1;
  switch (n) {
    case CONFIGURATION_EVENT_TYPE.one_on_one:
    case CONFIGURATION_EVENT_TYPE.max_availability:
    case CONFIGURATION_EVENT_TYPE.max_fairness:
      return h(
        Fragment,
        null,
        h(
          "nylas-event-info",
          null,
          h(
            "div",
            { slot: "inputs" },
            h("nylas-event-title", null),
            h("nylas-event-duration", null),
            h("nylas-event-location", { userProvider: r.provider })
          )
        ),
        h("nylas-booking-calendar-picker", { exportparts: "nbcp, nbcp__header, nbcp__dropdown, nbcp__dropdown-button, nbcp__dropdown-content", expressFlow: !0, calendars: t, currentUser: r, defaultBookingCalendar: a == null ? void 0 : a.id }),
        !l && h("nylas-scheduling-method", { showSubTitle: !0, exportparts: "nsm, nsm__header, nsm__input-label, nsm__dropdown, nsm__dropdown-button, nsm__dropdown-content" }),
        h("nylas-custom-event-slug", { name: "custom-event-slug", exportparts: "nces, nces__body, nces__header, nces__drawer-toggle--container, nces__input-textfield" })
      );
    case CONFIGURATION_EVENT_TYPE.collective:
      return h(
        Fragment,
        null,
        h(
          "nylas-event-info",
          null,
          h(
            "div",
            { slot: "inputs" },
            h("nylas-event-title", null),
            h("nylas-event-duration", null),
            h("nylas-event-location", { userProvider: r.provider })
          )
        ),
        h("nylas-booking-calendar-picker", { exportparts: "nbcp, nbcp__header, nbcp__dropdown, nbcp__dropdown-button, nbcp__dropdown-content", expressFlow: !0, calendars: t, currentUser: r, defaultBookingCalendar: a == null ? void 0 : a.id }),
        !l && h("nylas-scheduling-method", { showSubTitle: !0, exportparts: "nsm, nsm__header, nsm__input-label, nsm__dropdown, nsm__dropdown-button, nsm__dropdown-content" }),
        h("nylas-custom-event-slug", { name: "custom-event-slug", exportparts: "nces, nces__body, nces__header, nces__drawer-toggle--container, nces__input-textfield" }),
        h("nylas-additional-participants", { name: "participants", eventParticipants: [{ name: (r == null ? void 0 : r.name) || (r == null ? void 0 : r.email), email: (r == null ? void 0 : r.email) || "", is_organizer: !0 }], exportparts: "nadtnlpart, nadtnlpart__title, nadtnlpart__subtitle, nadtnlpart__content, nadtnlpart__input_group, nadtnlpart__input_wrapper, nadtnlpart__input, nadtnlpart__remove-participant" })
      );
    case CONFIGURATION_EVENT_TYPE.group:
      return h(
        Fragment,
        null,
        h(
          "nylas-event-info",
          null,
          h(
            "div",
            { slot: "inputs" },
            h("nylas-event-title", { noTemplates: !0 }),
            h("nylas-event-description", { noTemplates: !0, hideAutoPopulateButton: !0 }),
            h("nylas-event-location", { userProvider: r.provider }),
            h("nylas-event-timeslot", { name: "event-timeslot" }),
            h("nylas-event-capacity", null)
          )
        ),
        h("nylas-booking-calendar-picker", { exportparts: "nbcp, nbcp__header, nbcp__dropdown, nbcp__dropdown-button, nbcp__dropdown-content", expressFlow: !0, calendars: t, currentUser: r, defaultBookingCalendar: a == null ? void 0 : a.id }),
        h("nylas-additional-participants", { name: "participants", eventParticipants: [{ name: (r == null ? void 0 : r.name) || (r == null ? void 0 : r.email), email: (r == null ? void 0 : r.email) || "", is_organizer: !0 }], exportparts: "nadtnlpart, nadtnlpart__title, nadtnlpart__subtitle, nadtnlpart__content, nadtnlpart__input_group, nadtnlpart__input_wrapper, nadtnlpart__input, nadtnlpart__remove-participant" }),
        h("nylas-page-name", { requirePageName: !0, pageName: "Group events page" }),
        h("nylas-custom-event-slug", { name: "custom-event-slug", exportparts: "nces, nces__body, nces__header, nces__drawer-toggle--container, nces__input-textfield" })
      );
  }
}
const nylasSchedulerEditorCss = ':host{display:flex;flex-direction:column;overflow:visible;border-radius:var(--nylas-border-radius-2x);width:fit-content;background:var(--nylas-base-0);position:relative;box-shadow:0px 0px 6px -2px rgba(0, 0, 0, 0.05), 0px 5px 15px -3px rgba(0, 0, 0, 0.1);--nylas-primary:#2563eb;--nylas-error:#cc4841;--nylas-error-pressed:#992222;--nylas-wraning:#f06c00;--nylas-success:#16a392;--nylas-info:#2b8fc2;--nylas-base-0:#ffffff;--nylas-base-25:#fcfcfd;--nylas-base-50:#f8f9fc;--nylas-base-100:#eaecf5;--nylas-base-200:#d5d9eb;--nylas-base-300:#b3b8d8;--nylas-base-400:#717bbc;--nylas-base-500:#4e5ba6;--nylas-base-600:#3e4784;--nylas-base-700:#263f72;--nylas-base-800:#293056;--nylas-base-900:#101323;--nylas-base-950:#0e101b;--nylas-color-blue-100:#e0e6f9;--nylas-border-radius:0.25rem;--nylas-border-radius-2x:0.5rem;--nylas-border-radius-3x:0.75rem;--nylas-font-family:"Inter", sans-serif;--nylas-color-black:#000000;--nylas-color-grey-900:#2c2c2c;--nylas-color-grey-800:#4b4b4b;--nylas-color-grey-700:#6e6e6e;--nylas-color-grey-600:#8e8e8e;--nylas-color-grey-500:#b3b3b3;--nylas-color-grey-400:#cacaca;--nylas-color-grey-300:#e1e1e1;--nylas-color-grey-200:#eaeaea;--nylas-color-grey-100:#f5f5f5;--nylas-color-grey-50:#fbfcfe;--nylas-color-white:#ffffff;--nylas-color-red-900:#992222;--nylas-color-red-700:#cc4841;--nylas-color-red-500:#ff786a;--nylas-color-red-300:#ffa79e;--nylas-color-red-100:#ffc5bf;--nylas-color-red-50:#ffeae8;--nylas-color-blue-900:#213571;--nylas-color-blue-700:#314fa9;--nylas-color-blue-500:#4169e1;--nylas-color-blue-300:#bdccf9;--nylas-color-blue-100:#e0e6f9;--nylas-color-blue-50:#f6f8fd;--nylas-color-yellow-900:#7c6506;--nylas-color-yellow-700:#c29f09;--nylas-color-yellow-500:#f7c90b;--nylas-color-yellow-300:#f9de70;--nylas-color-yellow-100:#fceba9;--nylas-color-yellow-50:#fdf4ce;--nylas-color-green-900:#0e6b60;--nylas-color-green-700:#16a392;--nylas-color-green-500:#17c3b2;--nylas-color-green-300:#74dbd1;--nylas-color-green-100:#a2e7e0;--nylas-color-green-50:#d1f3f0;--nylas-color-purple-900:#643554;--nylas-color-purple-700:#954f7d;--nylas-color-purple-500:#c769a7;--nylas-color-purple-300:#dda5ca;--nylas-color-purple-100:#e0bdd6;--nylas-color-purple-50:#e9dde5;--nylas-color-sky-900:#20698f;--nylas-color-sky-700:#2b8fc2;--nylas-color-sky-500:#6dceff;--nylas-color-sky-300:#8fdaff;--nylas-color-sky-100:#b8e7ff;--nylas-color-sky-50:#d9f2ff}@media screen and (max-width: 768px){:host{width:-moz-available;width:-webkit-fill-available;width:fill-available;min-width:325px}}div.scheduler-editor-content{height:610px}div.scheduler-editor-content.scheduler-editor-content--group_feature_enabled{height:900px}@media screen and (max-width: 768px){div.scheduler-editor-content.scheduler-editor-content--group_feature_enabled{height:auto}}@media screen and (max-width: 768px){div.scheduler-editor-content{height:auto}}div.scheduler-editor-content--group{height:900px}@media screen and (max-width: 768px){div.scheduler-editor-content--group{height:auto}}div.scheduler-editor-header{display:grid;grid-template-columns:1fr auto auto;align-items:center;justify-content:space-between;padding:1rem;border-bottom:1px solid var(--nylas-base-200);color:var(--nylas-base-900);min-width:924px}@media screen and (max-width: 768px){div.scheduler-editor-header{width:auto;min-width:calc(325px - 1rem)}}div.scheduler-editor-header h1.scheduler-editor-title{display:flex;align-items:center;gap:0.5rem;margin:0;font-size:18px;line-height:24px;font-weight:600}div.scheduler-editor-header button{background:transparent;border:none;cursor:pointer}div.scheduler-editor-header button:hover,div.scheduler-editor-header button:active{color:var(--nylas-primary);background-color:transparent}div.scheduler-editor-header button:disabled{cursor:not-allowed}div.scheduler-editor-header div.language select-dropdown::part(sd_dropdown-button){border:none;padding:4px;margin-right:8px}div.scheduler-editor-header div.language select-dropdown::part(sd_dropdown-button):hover{outline:none;color:var(--nylas-primary)}div.scheduler-editor-header div.language select-dropdown::part(sd_dropdown-content){min-width:132px}@media screen and (max-width: 768px){div.scheduler-editor-header div.language select-dropdown::part(sd_dropdown-content){width:-webkit-fill-available;width:fill-available;width:-moz-available}}nylas-select-event-type{height:inherit;width:calc(924px + 2rem)}@media screen and (max-width: 768px){nylas-select-event-type{width:auto}}nylas-editor-tabs,nylas-editor-tabs-group{width:auto;height:inherit}nylas-editor-tabs .row,nylas-editor-tabs-group .row{display:flex;gap:1rem}nylas-editor-tabs .composable,nylas-editor-tabs-group .composable{height:inherit;overflow:auto}nylas-editor-tabs nylas-event-info div[slot=inputs],nylas-editor-tabs nylas-event-limits div[slot=inputs],nylas-editor-tabs-group nylas-event-info div[slot=inputs],nylas-editor-tabs-group nylas-event-limits div[slot=inputs]{display:flex;flex-direction:column;gap:1rem}.card{display:flex;flex-direction:column;padding:2rem;background-color:var(--nylas-base-0);border:1px solid var(--nylas-base-200);border-radius:5px;max-width:fit-content;align-self:center}.login-required{height:inherit;overflow-y:auto;display:flex;flex-direction:column;justify-content:center;padding:2rem 1rem;background-color:var(--nylas-base-25);border-radius:var(--nylas-border-radius-2x)}@media screen and (max-width: 768px){.login-required{height:auto}}.login-required p{margin:0 0 1rem}.login-required .microsoft-button,.login-required .google-button{height:48px;border:1px solid var(--nylas-base-300);border-radius:var(--nylas-border-radius-2x);font-size:16px;line-height:24px;padding:0 1rem;background-color:var(--nylas-base-0);font-weight:600;cursor:pointer;display:flex;margin-bottom:1rem;background-color:var(--nylas-base-0);border:1px solid var(--nylas-base-200);border-radius:5px;justify-content:center;gap:0.5rem;align-items:center}.login-required .microsoft-button:hover,.login-required .google-button:hover{background-color:var(--nylas-base-25)}.login-required .microsoft-button:hover,.login-required .google-button:hover{background-color:var(--nylas-base-25)}.login-required .other-provider-button{height:48px;border:1px solid var(--nylas-base-300);border-radius:var(--nylas-border-radius-2x);font-size:16px;line-height:24px;padding:0 1rem;background-color:var(--nylas-base-0);font-weight:600;cursor:pointer;display:flex;border:0;background-color:var(--nylas-base-0);height:48px;margin-bottom:1rem;font-size:0.95rem;justify-content:center;gap:0.25rem;align-items:center}.login-required .other-provider-button:hover{background-color:var(--nylas-base-25)}.login-required .other-provider-button svg{transform:rotate(180deg)}.login-required .other-provider-button:hover{background-color:var(--nylas-base-25)}.login-required .disclaimer-text{font-size:0.75rem;color:var(--nylas-base-600);align-self:center}.list-configurations{padding:2rem;height:inherit;background:var(--nylas-base-25);border-radius:var(--nylas-border-radius-2x)}@media screen and (max-width: 768px){.list-configurations{height:auto;padding:2rem 1rem}}.list-configurations nylas-list-configurations{height:inherit;display:flex;flex-direction:column}', NylasSchedulerEditorStyle0 = nylasSchedulerEditorCss, NylasSchedulerEditor = class {
  constructor(r) {
    registerInstance(this, r), this.init = createEvent(this, "init", 7), this.loggedIn = createEvent(this, "loggedIn", 7), this.loggedOut = createEvent(this, "loggedOut", 7), this.schedulerConfigCloseClicked = createEvent(this, "schedulerConfigCloseClicked", 7), this.handleSchedulerConfigCloseClicked = (t) => {
      const n = this.schedulerConfigCloseClicked.emit(this.host);
      "schedulerConfigCloseClicked" in this.eventOverrides && this.eventOverrides.schedulerConfigCloseClicked(n, this.nylasSchedulerConfigConnector), n.defaultPrevented || (localStorage.removeItem("grant"), localStorage.removeItem("user"), window.location.reload());
    }, this.authenticationUrl = async (t) => this.nylasApiRequest ? await this.nylasApiRequest.authenticationUrl({ provider: t }) || "" : (console.error("[nylas-scheduler-editor] Nylas API Request is not initialized."), ""), this.configurationId = void 0, this.nylasApiRequest = void 0, this.nylasSessionsConfig = void 0, this.defaultAuthArgs = void 0, this.eventOverrides = {}, this.schedulerPreviewLink = "", this.defaultSchedulerConfigState = void 0, this.mode = "app", this.additionalParticipants = void 0, this.hideEditorTabs = [], this.conferenceProviders = void 0, this.requiresSlug = !1, this.enableUserFeedback = !0, this.defaultLanguage = void 0, this.localization = void 0, this.nylasBranding = !0, this.experimentalFeatures = void 0, this.automaticComponentRegistration = !0, this.selectedLanguage = this.defaultLanguage || LANGUAGE_CODE.en, this.langVersion = 0;
  }
  connectedCallback() {
    debug("[nylas-scheduler-editor] connectedCallback");
  }
  async componentWillLoad() {
    var s, a, l, d, c, u, f, p;
    debug("[nylas-scheduler-editor] componentWillLoad");
    const r = (s = this.additionalParticipants) == null ? void 0 : s.filter((g) => {
      var y;
      const m = ((y = g.calendars) == null ? void 0 : y.length) > 0 ? g.calendars.filter((w) => w.id && w.name) : [];
      if (g.name && g.email && m.length > 0)
        return {
          name: g.name,
          email: g.email,
          calendars: m
        };
    });
    if (this.stores = {
      schedulerConfig: CreateNylasSchedulerConfigStore({
        ...this.defaultSchedulerConfigState,
        additionalParticipants: r,
        conferenceProviders: this.conferenceProviders,
        requiresSlug: this.requiresSlug,
        selectedLanguage: this.defaultLanguage || LANGUAGE_CODE.en,
        nylasBranding: this.nylasBranding,
        experimentalFeatures: this.experimentalFeatures
      })
    }, !this.nylasApiRequest && this.nylasSessionsConfig) {
      const g = new NylasSessions(this.nylasSessionsConfig);
      await g.isLoggedIn(), g.onLoginSuccess(async () => {
        var y, w;
        const m = await ((w = (y = this.nylasSchedulerConfigConnector) == null ? void 0 : y.schedulerConfig) == null ? void 0 : w.currentUser());
        if (m) {
          const b = this.loggedIn.emit(this.host);
          "loggedIn" in this.eventOverrides && await this.eventOverrides.loggedIn(b, this.nylasSchedulerConfigConnector), b.defaultPrevented || await this.loggedInHandler(m);
        }
      }), g.onLoginFail(async () => {
        var y, w;
        (w = (y = this.stores) == null ? void 0 : y.schedulerConfig) == null || w.set("currentUser", null);
        const m = this.loggedOut.emit(this.host);
        "loggedOut" in this.eventOverrides && (await this.eventOverrides.loggedOut(m, this.nylasSchedulerConfigConnector), m.defaultPrevented);
      }), this.nylasApiRequest = new NylasIdentityRequestWrapper(g);
    }
    this.nylasApiRequest && this.defaultAuthArgs && this.nylasApiRequest.setDefaultAuthArgs(this.defaultAuthArgs), this.baseProvider = new NylasBaseProvider(this.host, this.stores, this.automaticComponentRegistration, this.eventOverrides);
    const t = this.baseProvider.getStore("schedulerConfig");
    this.nylasSchedulerConfigConnector = new NylasSchedulerConfigConnector({
      nylasApiRequest: this.nylasApiRequest,
      nylasSchedulerConfigStore: t
    });
    const n = this.init.emit(this.host);
    if ("init" in this.eventOverrides && await this.eventOverrides.init(n, this.nylasSchedulerConfigConnector), !n.defaultPrevented) {
      const g = await ((l = (a = this.nylasSchedulerConfigConnector) == null ? void 0 : a.schedulerConfig) == null ? void 0 : l.currentUser());
      if (g) {
        const m = this.loggedIn.emit(this.host);
        "loggedIn" in this.eventOverrides && await this.eventOverrides.loggedIn(m, this.nylasSchedulerConfigConnector), m.defaultPrevented || await this.loggedInHandler(g);
      } else {
        (c = (d = this.stores) == null ? void 0 : d.schedulerConfig) == null || c.set("currentUser", null);
        const m = this.loggedOut.emit(this.host);
        if ("loggedOut" in this.eventOverrides && (await this.eventOverrides.loggedOut(m, this.nylasSchedulerConfigConnector), m.defaultPrevented))
          return;
      }
    }
    (f = (u = this.stores) == null ? void 0 : u.schedulerConfig) == null || f.onChange("selectedConfiguration", async (g) => {
      g && g.id && (this.configurationId = g.id);
    }), (p = this.baseProvider) == null || p.componentWillLoad(this.nylasSchedulerConfigConnector);
  }
  async componentDidLoad() {
    var r;
    debug("[nylas-scheduler-editor] componentDidLoad"), await ((r = this.baseProvider) == null ? void 0 : r.componentDidLoad()), this.updateLocalization(this.localization);
  }
  async componentDisconnected() {
    var r;
    await ((r = this.baseProvider) == null ? void 0 : r.componentDisconnected());
  }
  async configurationIdChanged(r) {
    var t, n, s, a, l, d, c, u;
    r ? (await ((n = (t = this.nylasSchedulerConfigConnector) == null ? void 0 : t.schedulerConfig) == null ? void 0 : n.getConfigurationById(r)), (a = (s = this.stores) == null ? void 0 : s.schedulerConfig) == null || a.set("action", "edit")) : ((d = (l = this.stores) == null ? void 0 : l.schedulerConfig) == null || d.set("selectedConfiguration", {}), (u = (c = this.stores) == null ? void 0 : c.schedulerConfig) == null || u.set("action", null));
  }
  updateLocalization(r) {
    r && (Object.keys(r).forEach((t) => {
      t in LANGUAGE_CODE && instance.addResourceBundle(t, "translation", r[t], !1, !0);
    }), this.langVersion++);
  }
  updateNylasBranding(r) {
    var t, n;
    (n = (t = this.stores) == null ? void 0 : t.schedulerConfig) == null || n.set("nylasBranding", r);
  }
  updateExperimentalFeatures(r) {
    var t, n;
    (n = (t = this.stores) == null ? void 0 : t.schedulerConfig) == null || n.set("experimentalFeatures", r);
  }
  async store() {
    var r;
    return (r = this.stores) == null ? void 0 : r.schedulerConfig;
  }
  async schedulerConnector() {
    return this.nylasSchedulerConfigConnector;
  }
  async registerComponentHandler(r) {
    var t;
    (t = this.baseProvider) == null || t.registerComponent(r.detail);
  }
  async unregisterComponentHandler(r) {
    var t;
    (t = this.baseProvider) == null || t.unregisterComponent(r.detail);
  }
  nylasFormDropdownChangedHandler(r) {
    var s, a;
    const { name: t, value: n } = r.detail;
    t === "language" && (this.selectedLanguage = LANGUAGE_CODE[n], instance.changeLanguage(this.selectedLanguage), (a = (s = this.stores) == null ? void 0 : s.schedulerConfig) == null || a.set("selectedLanguage", this.selectedLanguage));
  }
  async loggedInHandler(r) {
    var t, n, s, a, l, d, c;
    if ((n = (t = this.stores) == null ? void 0 : t.schedulerConfig) == null || n.set("currentUser", r), !!this.nylasSchedulerConfigConnector && (await ((s = this.nylasSchedulerConfigConnector.schedulerConfig) == null ? void 0 : s.getCalendars()), this.configurationId)) {
      const u = await ((a = this.nylasSchedulerConfigConnector.schedulerConfig) == null ? void 0 : a.getConfigurationById(this.configurationId));
      u && ((l = u[0]) != null && l.id) && ((c = (d = this.stores) == null ? void 0 : d.schedulerConfig) == null || c.set("action", "edit"));
    }
  }
  render() {
    var a, l, d, c, u, f, p, g, m, y, w, b, x, R, A, k, U, N, O, I, T, S, v, L, _, X, $, j, z, Y, M, V, J, W, Z, Q, ee, te, ne, se, re, oe, ie, ae, le, ce, de, he, ue, fe, ge, pe, ye, me, we, Se;
    const r = this.host.querySelector('[slot="custom-page-style-inputs"]'), t = (d = (l = (a = this.stores) == null ? void 0 : a.schedulerConfig) == null ? void 0 : l.state.selectedConfiguration) == null ? void 0 : d.id, n = Object.keys(LANGUAGE_MAP).map((q) => ({
      label: LANGUAGE_MAP[q],
      value: q
    })), s = ((u = (c = this.stores) == null ? void 0 : c.schedulerConfig) == null ? void 0 : u.state.selectedEventType) === CONFIGURATION_EVENT_TYPE.group || ((g = (p = (f = this.stores) == null ? void 0 : f.schedulerConfig) == null ? void 0 : p.state.selectedConfiguration) == null ? void 0 : g.type) === CONFIGURATION_EVENT_TYPE.group;
    return h(Host, { key: "c859b600874208d4ae1349f5838a834a69cbffa3" }, h("div", { key: "fb40121186bc57dbf4bba2560d77945b9e259f5b", class: "scheduler-editor-header", part: "nse__header" }, h("h1", { key: "91edbc1ae7967f6bf5c5a239393a6a5fa0f02f94", class: "scheduler-editor-title", part: "nse__title" }, h("calendar-icon", { key: "1e6798aacd0e004e6fc6ee486bbc681afbab7487", width: "18", height: "18" }), instance.t("schedulerEditorTitle")), h("div", { key: "b488780445f86b83035b474b52cb210f3805e229", class: {
      language: !0
    }, part: "nse__language" }, h("select-dropdown", { key: "baeaaaa703182988a6c99f58c9ca55a008ffa490", name: "language", searchPlaceholder: instance.t("search"), options: n, withChevron: !1, defaultSelectedOption: n.find((q) => q.value == this.selectedLanguage), exportparts: "sd_dropdown: nse__language-dropdown, sd_dropdown-button: nse__language-drop-button, sd_dropdown-content: nse__language-drop-content, sd_dropdown_label: nse__language-drop-label" }, h("span", { key: "31bea579d0d640218d3b8b4ac9240e1c2f467dbb", slot: "select-icon" }, h("translate-icon", { key: "c250969318fa8b8626019ef05d88beb187155cad", width: "20", height: "20" })))), h("button", { key: "aef03775ee2aaa4a8d6d15e9a1c833c5bcdf19c5", class: "scheduler-editor-close", title: "logout", onClick: (q) => this.handleSchedulerConfigCloseClicked(q), part: "nse__close-button" }, h("close-icon", { key: "43e2a903bc332d6c238c0250968abb62d7e14e51", width: "18", height: "18" }))), h("div", { key: "cfc1ce795dd551fe60ace249e9d5a8ab428b239e", class: {
      "scheduler-editor-content": !0,
      "scheduler-editor-content--group_feature_enabled": !!((w = (y = (m = this.stores) == null ? void 0 : m.schedulerConfig) == null ? void 0 : y.state.experimentalFeatures) != null && w[EXPERIMENTAL_FEATURES.group_events]),
      "scheduler-editor-content--group": s
    }, part: "nse__content" }, ((x = (b = this.stores) == null ? void 0 : b.schedulerConfig) == null ? void 0 : x.state.currentUser) && this.stores.schedulerConfig.state.action === null && h("div", { class: "list-configurations", part: "nse__list-configurations" }, h("nylas-list-configurations", { exportparts: "nlc__create-new-cta, actions__dropdown,  actions__dropdown-button, actions__dropdown-content, actions-Copy, actions-Preview, actions-Delete" })), ((A = (R = this.stores) == null ? void 0 : R.schedulerConfig) == null ? void 0 : A.state.currentUser) && this.stores.schedulerConfig.state.action === "create-select" && ((N = (U = (k = this.stores) == null ? void 0 : k.schedulerConfig) == null ? void 0 : U.state.experimentalFeatures) == null ? void 0 : N[EXPERIMENTAL_FEATURES.group_events]) && h("nylas-select-event-type", null), ((I = (O = this.stores) == null ? void 0 : O.schedulerConfig) == null ? void 0 : I.state.currentUser) && this.stores.schedulerConfig.state.action === "create" && s && h("nylas-editor-tabs-group", { mode: "composable" }, h(ExpressFlow, { experimentalFeatures: (v = (S = (T = this.stores) == null ? void 0 : T.schedulerConfig) == null ? void 0 : S.state) == null ? void 0 : v.experimentalFeatures, selectedEventType: ((X = (_ = (L = this.stores) == null ? void 0 : L.schedulerConfig) == null ? void 0 : _.state) == null ? void 0 : X.selectedEventType) || CONFIGURATION_EVENT_TYPE.one_on_one, currentUser: (j = ($ = this.stores) == null ? void 0 : $.schedulerConfig) == null ? void 0 : j.state.currentUser, calendars: (M = (Y = (z = this.stores) == null ? void 0 : z.schedulerConfig) == null ? void 0 : Y.state) == null ? void 0 : M.calendars, selectedConfiguration: (W = (J = (V = this.stores) == null ? void 0 : V.schedulerConfig) == null ? void 0 : J.state) == null ? void 0 : W.selectedConfiguration })), ((Q = (Z = this.stores) == null ? void 0 : Z.schedulerConfig) == null ? void 0 : Q.state.currentUser) && this.stores.schedulerConfig.state.action === "create" && !s && h("nylas-editor-tabs", { mode: "composable" }, h(ExpressFlow, { experimentalFeatures: (ne = (te = (ee = this.stores) == null ? void 0 : ee.schedulerConfig) == null ? void 0 : te.state) == null ? void 0 : ne.experimentalFeatures, selectedEventType: ((oe = (re = (se = this.stores) == null ? void 0 : se.schedulerConfig) == null ? void 0 : re.state) == null ? void 0 : oe.selectedEventType) || CONFIGURATION_EVENT_TYPE.one_on_one, currentUser: (ae = (ie = this.stores) == null ? void 0 : ie.schedulerConfig) == null ? void 0 : ae.state.currentUser, calendars: (de = (ce = (le = this.stores) == null ? void 0 : le.schedulerConfig) == null ? void 0 : ce.state) == null ? void 0 : de.calendars, selectedConfiguration: (fe = (ue = (he = this.stores) == null ? void 0 : he.schedulerConfig) == null ? void 0 : ue.state) == null ? void 0 : fe.selectedConfiguration })), ((pe = (ge = this.stores) == null ? void 0 : ge.schedulerConfig) == null ? void 0 : pe.state.currentUser) && this.stores.schedulerConfig.state.action === "edit" && s && h("nylas-editor-tabs-group", { key: t, mode: this.mode }, this.mode === "composable" && h("slot", null), this.mode === "app" && r && h("div", { style: { display: "none" }, slot: "custom-page-style-inputs", key: t }, h("slot", { name: "custom-page-style-inputs" }))), ((me = (ye = this.stores) == null ? void 0 : ye.schedulerConfig) == null ? void 0 : me.state.currentUser) && this.stores.schedulerConfig.state.action === "edit" && !s && h("nylas-editor-tabs", { key: t, mode: this.mode }, this.mode === "composable" && h("slot", null), this.mode === "app" && r && h("div", { style: { display: "none" }, slot: "custom-page-style-inputs", key: t }, h("slot", { name: "custom-page-style-inputs" }))), !((Se = (we = this.stores) == null ? void 0 : we.schedulerConfig) != null && Se.state.currentUser) && h("slot", { name: "login-required" }, h(LoginRequired, { authenticationUrl: this.authenticationUrl }))));
  }
  get host() {
    return getElement(this);
  }
  static get watchers() {
    return {
      configurationId: ["configurationIdChanged"],
      localization: ["updateLocalization"],
      nylasBranding: ["updateNylasBranding"],
      experimentalFeatures: ["updateExperimentalFeatures"]
    };
  }
};
NylasSchedulerEditor.style = NylasSchedulerEditorStyle0;
export {
  NylasSchedulerEditor as nylas_scheduler_editor
};
